import React from 'react'

import NotFoundPage from '~shared-components/pages/NotFound'

const NotFound: React.FC = () => <NotFoundPage />

export default NotFound
